import "../assets/index-4437e6bf.css";
import { N as n } from "../chunks/NcAppNavigationToggle-2574bba5.mjs";
import { useIsMobile as s } from "../Composables/useIsMobile.mjs";
import { g as p } from "../chunks/focusTrap-5d0f71d4.mjs";
import { subscribe as l, emit as o, unsubscribe as r } from "@nextcloud/event-bus";
import { createFocusTrap as g } from "focus-trap";
import { n as c } from "../chunks/_plugin-vue2_normalizer-71e2aa87.mjs";
const u = {
  name: "NcAppNavigation",
  components: {
    NcAppNavigationToggle: n
  },
  setup() {
    return {
      isMobile: s()
    };
  },
  props: {
    /**
     * The aria label to describe the navigation
     */
    ariaLabel: {
      type: String,
      default: ""
    },
    /**
     * aria-labelledby attribute to describe the navigation
     */
    ariaLabelledby: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      open: !0,
      focusTrap: null
    };
  },
  watch: {
    isMobile() {
      this.open = !this.isMobile, this.toggleFocusTrap();
    },
    open() {
      this.toggleFocusTrap();
    }
  },
  mounted() {
    l("toggle-navigation", this.toggleNavigationByEventBus), o("navigation-toggled", {
      open: this.open
    }), this.focusTrap = g(this.$refs.appNavigationContainer, {
      allowOutsideClick: !0,
      fallbackFocus: this.$refs.appNavigationContainer,
      trapStack: p(),
      escapeDeactivates: !1
    }), this.toggleFocusTrap();
  },
  unmounted() {
    r("toggle-navigation", this.toggleNavigationByEventBus), this.focusTrap.deactivate();
  },
  methods: {
    /**
     * Toggle the navigation
     *
     * @param {boolean} [state] set the state instead of inverting the current one
     */
    toggleNavigation(e) {
      this.open = typeof e > "u" ? !this.open : e;
      const t = getComputedStyle(document.body), a = parseInt(t.getPropertyValue("--animation-quick")) || 100;
      setTimeout(() => {
        o("navigation-toggled", {
          open: this.open
        });
      }, 1.5 * a);
    },
    toggleNavigationByEventBus({ open: e }) {
      this.toggleNavigation(e);
    },
    /**
     * Activate focus trap if it is currently needed, otherwise deactivate
     */
    toggleFocusTrap() {
      this.isMobile && this.open ? this.focusTrap.activate() : this.focusTrap.deactivate();
    },
    handleEsc() {
      this.isMobile && this.toggleNavigation(!1);
    }
  }
};
var d = function() {
  var t = this, a = t._self._c;
  return a("div", { ref: "appNavigationContainer", staticClass: "app-navigation", class: { "app-navigation--close": !t.open } }, [a("div", { staticClass: "app-navigation__toggle-wrapper" }, [a("NcAppNavigationToggle", { attrs: { open: t.open }, on: { "update:open": t.toggleNavigation } })], 1), a("nav", { staticClass: "app-navigation__content", attrs: { id: "app-navigation-vue", "aria-hidden": t.open ? "false" : "true", "aria-label": t.ariaLabel || void 0, "aria-labelledby": t.ariaLabelledby || void 0, inert: !t.open || void 0 }, on: { keydown: function(i) {
    return !i.type.indexOf("key") && t._k(i.keyCode, "esc", 27, i.key, ["Esc", "Escape"]) ? null : t.handleEsc.apply(null, arguments);
  } } }, [t._t("default"), a("ul", { staticClass: "app-navigation__list" }, [t._t("list")], 2), t._t("footer")], 2)]);
}, v = [], f = /* @__PURE__ */ c(
  u,
  d,
  v,
  !1,
  null,
  "926cf86d",
  null,
  null
);
const C = f.exports;
export {
  C as default
};
